import script from "./ItineraryReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItineraryReview.vue?vue&type=script&setup=true&lang=ts"

import "./ItineraryReview.vue?vue&type=style&index=0&id=e25659c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e25659c8"]])

export default __exports__